/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from 'react';
import { Row, Input, Card, CardBody, Label, Col, FormGroup } from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import SelectComponent from '@componentes/select/select.component';
import { useDispatch, useSelector } from 'react-redux';
import * as commonActions from '@common/common.action';
import { quadroKanbanEnum } from '@common/util/defaultValues';
import * as kanbanActions from '../../store/kanban.action';
import DragDropApi from '../../dragdrop.api';
import UteisHistologia from '../../../../pages/histologia/laminas/laminas.util';
import IntlMessage from "../../../../helpers/intlMessage";
import { useIntl } from 'react-intl';

export default function Histologia(props) {
	const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}
	const [destino, setDestino] = useState([]);
	const [destinos, setDestinos] = useState([]);
	const [selectGrid, setSelectGrid] = useState(0);
	const [lista, setLista] = useState([]);
	const kanbanState = useSelector((state) => state.kanban);
	const dispatch = useDispatch();

	const destinosLaminas = [
		{ label: `${intl.formatMessage({id:"dashboards.cytology.danglingBlades"}) }`, value: 'pendente' },
		{ label: `${intl.formatMessage({id:"dashboards.cytology.bladesInProgress"}) }`, value: 'executando' },
		{ label: `${intl.formatMessage({id:"dashboards.cytology.bladesReady"}) }`, value: 'laminas' },
	];

	useEffect(() => {
		const data = props.data[Object.keys(props.data)[0]];
		if (data && data.length > 0) {
			reset();

			if (props.lista && props.lamina) {
				carregarQtdLaminas(data);
			} else {
				insertSelect(data);
			}
		}
	}, [props.data]);

	useEffect(() => {
		const disabled = !selectGrid || destino.length === 0;
		dispatch(kanbanActions.atualizarMoverDisabled(disabled));
	}, [selectGrid, destino]);

	useEffect(() => {
		if (props.lista && props.lamina) {
			const ndestinos = [...destinosLaminas];
			setDestinos(ndestinos);
		} else if (props.lista.length === 4) {
			const ndestinos = [...props.destinos];
			props.destinos.find(
				(x, i) =>
					x.value === quadroKanbanEnum.HL_BLOCOS.id && delete ndestinos[i]
			);
			setDestinos(ndestinos);
		} else {
			setDestinos(props.destinos);
		}
	}, [props.destinos]);

	useEffect(() => {
		const disabled = !selectGrid || destino.length === 0;
		dispatch(kanbanActions.atualizarMoverDisabled(disabled));
	}, [selectGrid, destino]);

	useEffect(() => {
		if (props.click) {
			moverItens();
			props.onClick();
		}
	}, [props.click]);

	useEffect(() => {
		const data = props.data[Object.keys(props.data)[0]];
		if (kanbanState.laminas.length > 0 && data.length > 0) {
			insertSelect(data);
		}
	}, [kanbanState]);

	function reset() {
		dispatch(kanbanActions.atualizarLamina([]));
		dispatch(kanbanActions.atualizarMoverDisabled(true));
		setLista([]);
		setSelectGrid(0);
		setDestino([]);
	}

	function selectItem(e) {
		const tr = document.getElementsByTagName('tr');
		const checkboxes = document
			.getElementsByClassName('kanban-histologia-inclusao-modal-table')[0]
			.querySelectorAll('input[name=checkbox]:checked');
		setSelectGrid(checkboxes.length);
		const items = document
			.getElementsByClassName('kanban-histologia-inclusao-modal-table')[0]
			.getElementsByTagName('tr').length;

		if (checkboxes.length < items - 1)
			document.getElementById('selectMaterias').checked = false;
		else
			document.getElementById('selectMaterias').checked = true;

		for (let i = 0; i < tr.length - 1; i++) {
			let td = tr[i].getElementsByTagName('td');

			if (td.length > 0 && td[0].getElementsByTagName('input')[0])
				if (td[0].getElementsByTagName('input')[0].id === e.target.id)
					if (tr[i].getAttribute('datacheck') === 'true')
						tr[i].setAttribute('datacheck', 'false');
					else
						tr[i].setAttribute('datacheck', 'true');
		}
	}

	function onChangeSelect(e) {
		const tr = document.getElementsByTagName('tr');

		for (let i = 0; i < tr.length - 1; i++) {
			let td = tr[i].getElementsByTagName('td');

			if (td.length > 0 && td[0].getElementsByTagName('input')[0])
				if (td[0].getElementsByTagName('input')[0].id === e.data.itemId.toString())
					if (tr[i].getAttribute('datacheck') === 'true') {
						tr[i].setAttribute('datacheck', 'false');
						document.getElementById(e.data.itemId.toString()).checked = false;
					} else {
						tr[i].setAttribute('datacheck', 'true');
						document.getElementById(e.data.itemId.toString()).checked = true;
					}
		}

		const checkboxes = document
			.getElementsByClassName('kanban-histologia-inclusao-modal-table')[0]
			.querySelectorAll('input[name=checkbox]:checked');
		setSelectGrid(checkboxes.length);
		const items = document
			.getElementsByClassName('kanban-histologia-inclusao-modal-table')[0]
			.getElementsByTagName('tr').length;
		if (checkboxes.length < items - 1) {
			document.getElementById('selectMaterias').checked = false;
		} else {
			document.getElementById('selectMaterias').checked = true;
		}
	}

	function toggleCheckBox(checked) {
		const checkboxes = document
			.getElementsByClassName('kanban-histologia-inclusao-modal-table')[0]
			.getElementsByClassName('checkbox');
		for (let i = 0; i < checkboxes.length; i++) {
			if (checkboxes[i] !== checked) {
				checkboxes[i].checked = checked;
				const doc = document
					.getElementsByClassName('kanban-histologia-inclusao-modal-table')[0]
					.getElementsByTagName('tr')[i + 1];
				if (checked) {
					setSelectGrid(checkboxes.length);
					doc && doc.setAttribute('datacheck', 'true');
				} else {
					setSelectGrid(0);
					doc && doc.setAttribute('datacheck', 'false');
				}
			}
		}
	}

	function insertSelect(dados) {
		const novaLista = [];
		// eslint-disable-next-line array-callback-return
		dados.map((item) => {
			if (!item.isDragDisabled) {
				novaLista.push({
					itemId: item.id,
					exame: item.data.nrBloco ? item.data.nrBloco : item.data.nrLamina,
					// tipo: item.data.nrBloco ? 'BLOCO' : 'LÂMINA',
					tipo: item.data.tipoBloco
						? item.data.tipoBloco
						: item.data.tipoLamina,
					nomeTecnico: item.data.nomeTecnico,
					qtdLamina:
						kanbanState.laminas.length > 0 ? (
							<div className="qtd-laminas-group">
								<input
									className="qtd-laminas-button-remove float-left"
									id={`remove-laminas-${item.id}`}
									type="button"
									value="-"
									onClick={() => removeLamina(item.id)}
								/>

								<input
									className="qtd-laminas-button"
									id={`input-laminas-${item.id}`}
									style={{ width: '40px' }}
									type="number"
									defaultValue="1"
									onChange={(ev) => chanceLamina(item.id, ev.target.value)}
								/>
								<input
									className="qtd-laminas-button-add float-left"
									id={`add-laminas-${item.id}`}
									value="+"
									type="button"
									onClick={() => addLamina(item.id)}
								/>
							</div>
						) : (
							''
						),
					select: (
						<input
							className="checkbox"
							name="checkbox"
							type="checkbox"
							id={item.id}
							onClick={(e) => selectItem(e)}
						/>
					),
				});
			}
		});
		setLista(novaLista);
	}

	function getIconeStatus(value) {
		let icone;
		let status;

		if (
			Object.keys(props.lista[0])[0] === quadroKanbanEnum.HL_BLOCOS.id &&
			value === quadroKanbanEnum.HL_PENDENTES.id
		) {
			icone = quadroKanbanEnum.HL_PENDENTES.icone;
			status = quadroKanbanEnum.HL_PENDENTES.status;
		} else if (
			Object.keys(props.lista[0])[0] === quadroKanbanEnum.HL_BLOCOS.id &&
			value === quadroKanbanEnum.HL_EXECUTANDO.id
		) {
			icone = quadroKanbanEnum.HL_EXECUTANDO.icone;
			status = quadroKanbanEnum.HL_EXECUTANDO.status;
		} else if (
			Object.keys(props.lista[0])[0] === quadroKanbanEnum.HL_BLOCOS.id &&
			value === quadroKanbanEnum.HL_PRONTAS.id
		) {
			icone = quadroKanbanEnum.HL_PRONTAS.id;
			status = quadroKanbanEnum.HL_PRONTAS.status;
		} else if (
			Object.keys(props.lista[0])[0] === quadroKanbanEnum.HI_CASSETE.id &&
			value === quadroKanbanEnum.HI_CASSETE.id
		) {
			icone = quadroKanbanEnum.HI_CASSETE.icone;
			status = quadroKanbanEnum.HI_CASSETE.status;
		} else if (
			Object.keys(props.lista[0])[0] === quadroKanbanEnum.HI_CASSETE.id &&
			value === quadroKanbanEnum.HI_EXECUTANDO.id
		) {
			icone = quadroKanbanEnum.HI_EXECUTANDO.icone;
			status = quadroKanbanEnum.HI_EXECUTANDO.status;
		} else if (
			Object.keys(props.lista[0])[0] === quadroKanbanEnum.HI_CASSETE.id &&
			value === quadroKanbanEnum.HI_BLOCOS.id
		) {
			icone = quadroKanbanEnum.HI_BLOCOS.icone;
			status = quadroKanbanEnum.HI_BLOCOS.status;
		} else if (
			Object.keys(props.lista[0])[0] === quadroKanbanEnum.HI_CASSETE.id &&
			value === quadroKanbanEnum.HL_PRONTAS.id
		) {
			icone = quadroKanbanEnum.HL_PRONTAS.icone;
			status = quadroKanbanEnum.HL_PRONTAS.status;
		}
		return { icone, status };
	}

	function montarLaminas(itens) {
		const laminas = [];
		const id = Object.keys(props.data)[0];
		for (let i = 0; i < itens.length; i++) {
			// eslint-disable-next-line no-loop-func
			// eslint-disable-next-line array-callback-return
			lista.find((l) => {
				if (l.itemId === Number(itens[i].id) || l.itemId === itens[i].id) {
					const item = props.data[id].find((x) => x.id === l.itemId);
					const iconeStatus = getIconeStatus(destino.value);
					laminas.push({
						cdAnticorpo: 0,
						lamina: item.data.id,
						status: iconeStatus.status,
					});
				}
			});
		}
		return laminas;
	}

	function montarCassete(itens) {
		const cassetes = [];
		const id = Object.keys(props.data)[0];
		for (let i = 0; i < itens.length; i++) {
			// eslint-disable-next-line no-loop-func
			// eslint-disable-next-line array-callback-return
			lista.find((l) => {
				if (l.itemId === Number(itens[i].id) || l.itemId === itens[i].id) {
					const item = props.data[id].find((x) => x.id === l.itemId);
					const iconeStatus = getIconeStatus(destino.value);
					cassetes.push({
						laudoBloco: item.data.id,
						status: iconeStatus.status,
					});
				}
			});
		}
		return cassetes;
	}

	function montarLoteLaminas(itens) {
		// kanbanState.laminas
		const lote = [];
		const id = Object.keys(props.data)[0];
		for (let i = 0; i < itens.length; i++) {
			// eslint-disable-next-line no-loop-func
			// eslint-disable-next-line array-callback-return
			lista.find((l) => {
				if (l.itemId === Number(itens[i].id) || l.itemId === itens[i].id) {
					const item = props.data[id].find((x) => x.id === l.itemId);
					const iconeStatus = getIconeStatus(destino.value);
					lote.push({
						nrBloco: item.data.nrBloco,
						blocoID: item.data.id,
						laudoID: item.data.cdLaudo,
						medicoID: 0,
						tecnicoID: item.data.idTecnico,
						sentinelaMama: item.data.sentinelaMama,
						sentinelaMelanoma: item.data.sentinelaMelanoma,
						complemento: null,
						lamina: UteisHistologia.getTipoLamina(item.data.tipoBloco, intl).nome,
						qtd: kanbanState.laminas.find((x) => x.exame === item.data.nrBloco)
							.value,
						cdAnticorpo: 0,
						destino: 'NAO_INFORMADO',
						status: iconeStatus.status,
					});
				}
			});
		}

		return lote;
	}

	async function moverItens() {
		dispatch(commonActions.showFadeCarregando(true));

		const data = document
			.getElementsByClassName('kanban-histologia-inclusao-modal-table')[0]
			.querySelectorAll('input[name=checkbox]:checked');
		const id = Object.keys(props.data)[0];
		const source = {
			droppableId: id,
			index: props.lista.findIndex((x) => Object.keys(x)[0] === id),
			...getIconeStatus(id),
		};

		const destination = {
			droppableId: destino.value,
			index: props.lista.findIndex((x) => Object.keys(x)[0] === destino.value),
			...getIconeStatus(destino.value),
		};

		if (kanbanState.laminas.length > 0) {
			// Histologia Lâmina
			const payload = montarLoteLaminas(data, source, destination);
			const lote = { laminas: payload };

			const sendBlocos = await DragDropApi.criarLaminas(lote);
			if (sendBlocos.success) {
				dispatch(kanbanActions.atualizarNovasLaminas(sendBlocos.success));
				dispatch(
					commonActions.showAlerta(
						'sucesso',
						<IntlMessage id="dashboards.sample.itemsMovedSuccessfully" />,
						1500
					)
				);
			} else {
				dispatch(
					commonActions.showAlerta(
						'erro',
						`Erro ao mover os itens selecionados.`,
						1500
					)
				);
				dispatch(commonActions.showFadeCarregando(false));
			}
		} else {
			// Histologia Inclusão
			if (Object.keys(props.lista[0])[0] === quadroKanbanEnum.HI_CASSETE.id) {
				const payload = montarCassete(data, source, destination);
				const cassetes = { cassetes: payload };
				const sendInclusao = await DragDropApi.moverCassetes(cassetes);

				if (sendInclusao.success) {
					dispatch(kanbanActions.atualizarNovasLaminas(true));
					dispatch(
						commonActions.showAlerta(
							'sucesso',
							<IntlMessage id="dashboards.sample.itemsMovedSuccessfully" />,
							1500
						)
					);
				} else {
					dispatch(
						commonActions.showAlerta(
							'erro',
							`Erro ao mover os itens selecionados.`,
							1500
						)
					);
					dispatch(commonActions.showFadeCarregando(false));
				}
				// Histologia Lâmina
			} else if (
				Object.keys(props.lista[0])[0] === quadroKanbanEnum.HL_BLOCOS.id
			) {
				const payload = montarLaminas(data, source, destination);
				const laminas = { laminas: payload };
				const sendLaminas = await DragDropApi.moverLaminas(laminas);

				if (sendLaminas.success) {
					dispatch(kanbanActions.atualizarNovasLaminas(true));
					dispatch(
						commonActions.showAlerta(
							'sucesso',
							<IntlMessage id="dashboards.sample.itemsMovedSuccessfully" />,
							1500
						)
					);
				} else {
					dispatch(
						commonActions.showAlerta(
							'erro',
							`Erro ao mover os itens selecionados.`,
							1500
						)
					);
				}
			}
			//dispatch(commonActions.showFadeCarregando(false));
		}

		return dispatch(kanbanActions.atualizarModal(false));
	}

	function chanceLamina(id, val) {
		const nlaminas = [...kanbanState.laminas];
		const btnRemover = document.getElementById(`remove-laminas-${id}`);
		const el = document.getElementById(`input-laminas-${id}`);
		const value = val.toString();
		// eslint-disable-next-line array-callback-return
		kanbanState.laminas.find((item, index) => {
			if (item.id === id) {
				el.value = value;
				nlaminas[index].value = value;
			}
			if (value < 2) {
				document.getElementById(`input-laminas-${id}`).value = 1;
				btnRemover.disabled = true;
			} else {
				btnRemover.disabled = false;
			}
		});
		return (
			nlaminas.length > 0 && dispatch(kanbanActions.atualizarLamina(nlaminas))
		);
	}

	function addLamina(id) {
		const value =
			Number(document.getElementById(`input-laminas-${id}`).value) + 1;
		const btnRemover = document.getElementById(`remove-laminas-${id}`);
		if (value < 2) {
			document.getElementById(`input-laminas-${id}`).value = 1;
			btnRemover.disabled = true;
		} else {
			btnRemover.disabled = false;
		}
		chanceLamina(id, value);
	}

	function removeLamina(id) {
		let value =
			Number(document.getElementById(`input-laminas-${id}`).value) - 1;
		const btnRemover = document.getElementById(`remove-laminas-${id}`);
		if (value < 2) {
			value = 1;
			btnRemover.disabled = true;
		} else {
			btnRemover.disabled = false;
		}
		chanceLamina(id, value);
	}

	async function carregarQtdLaminas(dados) {
		const tempLaminas = [];
		// eslint-disable-next-line array-callback-return
		dados.map((item) => {
			tempLaminas.push({
				id: item.id,
				value: '1',
				exame: item.data.nrBloco ? item.data.nrBloco : item.data.nrLamina,
			});
		});
		dispatch(kanbanActions.atualizarLamina(tempLaminas));
	}

	return (
		<Card>
			<CardBody>
				<Row>
					<Col sm={6}>
						<FormGroup>
							<Label className="label-data" style={{ float: 'left' }}>
								{`${ intl.formatMessage({id:"dashboards.cytology.origin"}) }`}
							</Label>
							<Input
								className="col-9"
								value={props.data.title && props.data.title.text}
								disabled
							/>
						</FormGroup>
					</Col>
					<div className="col-6">
						<Label className="label-data col-auto" style={{ float: 'left' }}>
						{`${intl.formatMessage({id:"dashboards.cytology.destiny"}) }`}
						</Label>
						<SelectComponent
							onChange={(e) => setDestino(e)}
							className="col-auto"
							value={destino}
							options={destinos}
							placeholder={translate("dashboards.cytology.selectDestiny")}
						/>
					</div>
				</Row>
				<br />
				<DataTable
					className="kanban-histologia-inclusao-modal-table"
					onContextMenu={(e) => onChangeSelect(e)}
					value={lista}
					responsive
					selectionMode="single"
					style={{ height: '100%' }}
					columnResizeMode="expand"
					scrollable
					scrollWidth="100%"
					lazy
					paginator={false}
					emptyMessage={<IntlMessage id = "dashboards.reports.noResultsFound"/>}
					alwaysShowPaginator={false}
					autoLayout
				>
					<Column
						sortable={false}
						field="select"
						style={{ width: '25px', verticalAlign: 'middle' }}
						header={
							lista.length >= 1 && (
								<input
									type="checkbox"
									id="selectMaterias"
									name="selectMaterias"
									onChange={(e) => {
										toggleCheckBox(e.target.checked);
									}}
								/>
							)
						}
					/>

					<Column
						sortable={false}
						field="exame"
						style={{
							width: '150px',
							verticalAlign: 'middle',
						}}
						header={`${intl.formatMessage({id:"general.materialArchiving.identification"}) }`}
					/>

					<Column
						sortable={false}
						field="tipo"
						style={{ width: '150px', verticalAlign: 'middle' }}
						header={`${intl.formatMessage({id: 'general.materialArchiving.type'})} ${intl.formatMessage({id: 'general.materialArchiving.material'})}`}
					/>

					<Column
						sortable={false}
						field="nomeTecnico"
						style={{ width: '180px', verticalAlign: 'middle' }}
						header={<IntlMessage id="dashboards.sample.technicianName" />}
					/>

					<Column
						style={
							!kanbanState.laminas.length > 0
								? { display: 'none' }
								: { width: '120px' }
						}
						sortable={false}
						field="qtdLamina"
						header={<IntlMessage id="dashboards.examDetails.blade" />}
					/>
				</DataTable>
			</CardBody>
		</Card>
	);
}



// WEBPACK FOOTER //
// ./src/componentes/dragdrog/containers/HistologiaTabs/histologia.jsx